import { render, staticRenderFns } from "./Dues.vue?vue&type=template&id=47ffbe84&scoped=true&"
import script from "./Dues.vue?vue&type=script&lang=js&"
export * from "./Dues.vue?vue&type=script&lang=js&"
import style0 from "./Dues.vue?vue&type=style&index=0&id=47ffbe84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ffbe84",
  null
  
)

export default component.exports